<template>
  <div pageF>
    <article>
      <div class="cover">
        <div class="cont">
          <h2></h2>
          <div class="slide-cover" v-if="env==='pc'">
            <slider ref="slide" :pagination="false" :navigation="false" :option="option">
              <div class="swiper-slide" v-for="(item,id) in pcSlide" :key="id" v-if="item.img">
                <p :style="{backgroundImage:`url('${getImage(item.img)}')`}">
                  <a @click="setMovOn(item.mov,id)"></a>
                </p>
              </div>
            </slider>
            <ul class="page-bts">
              <li><a @click="goNext(false)"></a></li>
              <li><a @click="goNext(true)"></a></li>
            </ul>
          </div>

          <div class="list">
            <ul>
              <li v-for="(item,id) in pcSlide" :key="id" :style="{backgroundImage:`url('${getImage(item.thumb)}')`}" :class="[{on: usable[activeId] === id}, `thumb${id+1}`]">
                <a @click="checkUsable(id)"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>

import $ from 'jquery';
import _ from 'lodash';
import Slider from '../components/Slider.vue';

export default {
  name: 'pageF',
  components: { Slider },
  computed: {
    env() {
      return this.$store.state.environment;
    },
  },
  watch: {
    $route() {
      this.reset();
    },
  },
  data() {
    return {
      activeId: 0,
      imgUrl: '/static/img/',
      usable: [0, 1, 2, 3, 4, 5, 6],
      pcSlide: [
        { thumb: 't1.png', img: 'img1.jpg', mov: 'IyE-H-IGI0Y' },
        { thumb: 't2.png', img: 'img2.jpg', mov: 'KCp6vDna83w' },
        { thumb: 't3.png', img: 'img3.jpg', mov: 'wDabB_XwbBs' },
        { thumb: 't4.png', img: 'img4.jpg', mov: 'DOtrpBnJHH4' },
        { thumb: 't5.png', img: 'img5.jpg', mov: 'Cz8tCAc8B8w' },
        { thumb: 't6.png', img: 'img6.jpg', mov: 'rBBj7Wsc4xo' },
        { thumb: 't7.png', img: 'img7.jpg', mov: 'xTl7cYc4RJI' },
        { thumb: 't8.png', img: null, mov: null },
      ],

      option: {
        loop: false,
        spaceBetween: 0,
        speed: 500,
        on: {
          slideChange: this.slideChange,
        },
      },
    };
  },
  methods: {
    reset() {
      if (this.$route.name === 'media' && this.$route.query.reset === 'Y' && this.$route.query.code) {
        // this.setActiveView((Number(this.$route.query.code) + 1) || 1);
        const target = $(`.thumb${this.$route.query.code}`);
        if (target.length > 0) {
          const offset = target.offset();
          $(window).scrollTop(offset.top - 150);
        }
      }
    },
    setMovOn(mov, id) {
      if (id < 4) {
        window.gtag('event', 'click', { event_category: 'Media' });
      } else {
        window.gtag('event', 'click', { event_category: 'Media' });
      }
      this.$store.commit('onMov', `https://www.youtube.com/embed/${mov}`);
    },

    getImage(item) {
      return `${this.imgUrl}${this.env}/p6/${item}`;
    },

    slideChange() {
      this.activeId = this.$refs.slide.now();
    },
    goNext(next) {
      let activeId = this.activeId + (next ? 1 : -1);
      activeId = next && activeId > this.usable.length - 1 ? 0 : !next && activeId < 0 ? this.usable.length - 1 : activeId;
      this.setActiveView((activeId % this.usable.length));
    },
    checkUsable(id) {
      if (!this.pcSlide[id].mov) {
        this.$store.commit('onMsg', 'Coming Soon!');
        return;
      }
      id = _.findIndex(this.usable, o => id === o);
      this.setActiveView(id);
    },
    setActiveView(id) {
      this.activeId = Number(id);
      if (this.env === 'pc') {
        this.$refs.slide.goToSlide(this.activeId);
      } else if (this.pcSlide[this.usable[id]].mov) {
        this.$store.commit('onMov', `https://www.youtube.com/embed/${this.pcSlide[this.usable[id]].mov}`);
      }
    },
  },
  mounted() {
    if (this.env === 'pc' && this.$route.query.code) {
      setTimeout(() => {
        if (!this.pcSlide[this.$route.query.code - 1].mov) return;
        this.setActiveView(_.findIndex(this.usable, o => this.$route.query.code - 1 === o) + 1);
      }, 100);
    }
  },
};
</script>

<style lang="less">
  @import '../less/proj';
  .mob{
    [pageF]{.rel; .w(100%);  .cover("@{mob}/p6/bg.jpg");
      .cover{ .pt(90); .pb(200);
        .cont{
          >*{.mh-c;}
          h2{.contain("@{mob}/p6/title.png"); .wh(175,77);}

          .list{.w(100%); .tc;
            ul{ .mh-c; .w(600);  .rel; .pt(220);
              &:before{.cnt; .abs; .contain("@{mob}/p6/subtitle1.png"); .wh(100%,100); .t(94); .l(50%); .ml(-300);}
              &:after{.cnt; .abs; .contain("@{mob}/p6/subtitle2.png"); .wh(100%,50); .t(1575); .l(50%); .ml(-300);}
              li{.wh(100% ,260); .no-repeat; .mb(48); .bg-s(100%,100%); .block;  box-shadow: 4px 5px 4px 5px rgba(0,0,0,0.5);
                a{.block; .wh(100%); transition:.3s;}
                &:nth-of-type(4){.mb(250);}
              }
            }
          }
        }
      }
    }
  }

  .pc{
    [pageF]{.fix; .cover; .bg-x(50%); .wh(100%); .-box; .min-h(100%); .-box; .min-w(1140px); .fix; .cover("@{pc}/p6/bg.jpg"); transition: .5s;
      article { .w(100%); .abs; .t(85px); .b(78px);
        .cover{ .wh(100%); .rel; overflow-y:auto; overflow-x:hidden; -webkit-overflow-scrolling: touch;
          .cont{ .w(1044px); .mh-c; .abs; .l(50%); .t(50%); transform: translate(-50%,-50%); .h(1140px);
            >*{.mh-c;}
            h2{.contain("@{pc}/p6/title.png"); .wh(186px,75px); .mb(30px);}
            .slide-cover{.wh(100%,458px); .rel;
              .swiper-container{.wh(817px,100%); box-shadow: 0 1px 1px 1px rgba(0,0,0,0.4);
                .swiper-wrapper{.wh(100%);
                  .swiper-slide{.wh(100%);
                    p{ .block; .wh(100%); .no-repeat;
                      a{.abs; .block; .wh(77px,77px); .bg-c;  .contain("@{pc}/btn-play.png"); .l(50%); .ml(-38px); .t(50%); .mt(-38px);}
                    }
                  }
                }
              }
            }

            .list{.w(900px); .tc; .mt(47px);
              ul{.ib-list; .mh-c; .w(830px);  .rel; .pl(8px);
                &:before{.cnt; .abs; .contain("@{pc}/p6/subtitle1.png"); .wh(100%,30px); .t(0); .bg-c;}
                &:after{.cnt; .abs; .contain("@{pc}/p6/subtitle2.png"); .wh(100%,30px); .t(255px); .bg-c;}
                li{.wh(199px ,160px); .no-repeat; .m(47px,3px); .bg-s(100%,100%); .pointer;
                  a{.block; .wh(100%); transition:.3s; .-a(#FF000000);}
                  &.on{
                    a{  .-a(#FF0000); .-box;}
                  }
                }
              }
            }
          }
        }
      }
      @media screen and (max-width: @screen-xxl-min){
        article{.t(63px); .b(56px);}
      }

      @media screen and (max-height: 1440px){
        article{
          .cover{
            .cont{transform:translate(-50%,0); .t(100px);}
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pageF.vue